"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AudioMenu_1 = __importDefault(require("./AudioMenu"));
exports.default = AudioMenu_1.default;
